import React from 'react';
import { ColumnsType } from 'antd/es/table';

import { getTableSortOrder } from '../../common/getTableSortOrder';
import { LinkTableCell } from '../../components/LinkTableCell';
import { PageRoutesEnum } from '../../utils/routes';

import { EmailsDataSourceType } from './useEmailsTableDataSource';

export const useEmailsTableColumnDefinitions = ({
  sortedInfo,
}: {
  sortedInfo: { field: string; order: string }[];
}): ColumnsType<EmailsDataSourceType> => {
  const emailColumns = [
    {
      title: 'Sent date',
      dataIndex: 'sentDate',
      sorter: {
        compare: () => 0,
        multiple: 1,
      },
      sortOrder: getTableSortOrder(sortedInfo, 'sentDate'),
    },
    {
      title: 'From',
      dataIndex: 'from',
      sorter: {
        compare: () => 0,
        multiple: 1,
      },
      sortOrder: getTableSortOrder(sortedInfo, 'from'),
    },
    {
      title: 'Subject',
      dataIndex: 'subject',
      sorter: {
        compare: () => 0,
        multiple: 1,
      },
      sortOrder: getTableSortOrder(sortedInfo, 'subject'),
    },
  ];

  return emailColumns.map((column) => ({
    ...column,
    render: (text: string, record: EmailsDataSourceType) => (
      <LinkTableCell text={text} record={record} pageRoute={PageRoutesEnum.emailDetails} />
    ),
  }));
};
